import { render } from "./itemProductPopup.vue?vue&type=template&id=4e5b5dc7&scoped=true"
import script from "./itemProductPopup.vue?vue&type=script&lang=js"
export * from "./itemProductPopup.vue?vue&type=script&lang=js"

import "./itemProductPopup.vue?vue&type=style&index=0&id=4e5b5dc7&lang=stylus"
import "./itemProductPopup.vue?vue&type=style&index=1&id=4e5b5dc7&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5b5dc7"]])

export default __exports__